// extracted by mini-css-extract-plugin
export default {"genericCard":"oo-z","inline":"po-z","mastercard":"qo-z","discover":"ro-z","visa":"so-z","amex":"to-z","active":"uo-z"};